import {
  createAsyncThunk,
  createSlice,
  isAnyOf,
  PayloadAction,
} from '@reduxjs/toolkit';
import moment from 'moment-tz';

import {
  markUserJobAsViewedFetcher,
  userJobDetailsFetcher,
} from 'app/jobs/fetchers';

import {UserJobSerializedType} from 'sweet-types';

export const fetchUserJobDetails = createAsyncThunk<
  UserJobSerializedType,
  string
>('userjobs/fetchUserJobDetails', (url: string) => {
  return userJobDetailsFetcher(url);
});

export const markUserJobAsViewed = createAsyncThunk<
  UserJobSerializedType,
  string
>('userjobs/markUserJobAsViewed', (url) => {
  return markUserJobAsViewedFetcher(url, {viewed_at: moment().utc().format()});
});

export interface JobsState {
  byId: {[id: string]: UserJobSerializedType};
}

const initialState: JobsState = {
  byId: {},
};

const jobsSlice = createSlice({
  name: 'jobs',
  initialState,
  reducers: {
    receiveUserJobDetail: (
      state,
      action: PayloadAction<UserJobSerializedType>
    ) => {
      state.byId[action.payload.id] = action.payload;
    },
  },
  extraReducers: (builder) =>
    builder.addMatcher(
      isAnyOf(fetchUserJobDetails.fulfilled, markUserJobAsViewed.fulfilled),
      (state, {payload: job}) => {
        state.byId[job.id] = job;
      }
    ),
});

export const jobsReducer = jobsSlice.reducer;

export const {receiveUserJobDetail} = jobsSlice.actions;
